import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

/**
 * Application entry-point.
 */

import App from './App.tsx';
import { captureReferralFromUrl } from './lib/referral';

// PRP-MCP-10: keep an affiliate ?ref= code (90-day cookie) before any redirect drops it.
captureReferralFromUrl();

/**
 * A simple Error Boundary to catch runtime errors in any child component
 * and display a friendly fallback UI instead of a blank screen.
 */
class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex h-screen flex-col items-center justify-center bg-background px-4 text-center">
          <h1 className="mb-2 text-3xl font-bold text-primary">
            Something went wrong.
          </h1>
          <p className="max-w-md text-muted-foreground">
            An unexpected error occurred. Please refresh the page or try again
            later.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
// Force deployment trigger Tue Jul  1 13:04:34 EDT 2025
